/**
 * Contexto de seção do manual visível na tela.
 *
 * Funciona como uma "memória de contexto" compartilhada: a página do manual
 * publica aqui qual seção está na tela (pela rolagem) e a Beaa lê esse valor
 * ao responder — assim ela prioriza o conteúdo daquela seção, sem precisar
 * de clique. É o embrião do contexto que, no futuro, alimenta um RAG.
 */

export interface SecaoManualAtiva {
  /** Âncora da seção (id HTML, igual ao `secao` do artigo no banco). */
  id: string;
  /** Título legível da seção, usado nas mensagens da Beaa. */
  titulo: string;
  /** Rota da página do manual, para montar o link de retorno ao trecho. */
  rota: string;
}

let secaoAtiva: SecaoManualAtiva | null = null;

/** Publica a seção visível no momento (ou null quando não há seção do manual na tela). */
export function setSecaoAtivaManual(secao: SecaoManualAtiva | null): void {
  secaoAtiva = secao;
}

/** Lê a seção visível mais recente. */
export function getSecaoAtivaManual(): SecaoManualAtiva | null {
  return secaoAtiva;
}